import { ChatMessage } from '@prisma/client'
import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderUIChatV2Common = {
  key: 'uichatV2',
  authentication: ProviderAuthenticationCommon.Form(),
}

export type ProviderUIChatAccountType = null

export type UIChatAttachment = {
  uid: string
  lastModified: number
  lastModifiedDate: Date
  size: number
  type: string
  percent: number
  status: string
  name: string
  urlPrivate: string
}

export type UIChatPost = {
  appKey: string
  content: string
  attachments?: UIChatAttachment[]
}

export type UIChatReactionType = '👍' | '👎'

export type UIChatMessage = Omit<ChatMessage, 'values'> & {
  values: {
    attachments?: UIChatAttachment[]
    posts?: UIChatPost[]
    reactions?: UIChatReactionType[]
    isHidden: boolean
    isChecked: boolean
  }
}
